import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { FiltersDropdownPopover } from './components/FiltersDropdownPopover';
import { FiltersModal } from './components/FiltersModal';
import { IDialogFilterItem } from '../../types/filterSelectors';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';

interface IDialogChipPopupProps {
  open: boolean;
  dialogFilters: IDialogFilterItem[];
  dialogTitle: string;
  dropdownAnchor: React.ReactElement<any>;
  chipRef?: React.RefObject<HTMLLIElement | null>;
  onChange: (jsonQuery: IJsonQuery, isActive: boolean) => void;
  onClose: () => void;
}

const DEFAULT_CHIP_REF = React.createRef<HTMLLIElement>();

export const DialogChipPopup: React.FC<IDialogChipPopupProps> = ({
  open,
  dialogFilters,
  dialogTitle,
  dropdownAnchor,
  chipRef,
  onChange,
  onClose,
}) => {
  const handleFilter = React.useCallback(
    (item: IDialogFilterItem) => {
      onClose();
      onChange(item.jsonQuery, false);
    },
    [onChange, onClose],
  );

  return (
    <>
      <Responsive desktop tablet>
        <FiltersDropdownPopover
          anchor={dropdownAnchor}
          chipRef={chipRef ?? DEFAULT_CHIP_REF}
          filters={dialogFilters}
          open={open}
          onClose={onClose}
          onFilter={handleFilter}
        />
      </Responsive>
      <Responsive phone>
        <FiltersModal
          filters={dialogFilters}
          open={open}
          title={dialogTitle}
          onClose={onClose}
          onFilter={handleFilter}
        />
      </Responsive>
    </>
  );
};
